  /* 国际化zh_tw */

module.exports = {
    base:{
        "nomore" : "沒有更多了",
        "sure" : "确定",
        "not_desc" : "暂无描述",
    },
    common:{
        "get_code" : "获取验证码",
        "onsale_status" : "该商品已下架",
        "s_regain" : "s后重新获取",
        "regain" : "重新获取",
        "cancel" : "取消",
        "select" : "选取",
        "empty_item" : "暂无内容",
        "load_fail" : "加载失败",
        "tabbar_my_name" : "我的",
    },
    tabbar:{
        "home" : "首页",
        "category" : "分类",
        "cart" : "购物车",
        "profile" : "我的",
        "QQ" : "QQ", //客服

    },
    address:{
        "name" : "收件人姓名",
        "name_placeholder" : "请如实填写收货人姓名",
        "mobile" : "手机号码",
        "mobile_placeholder" : "请填写个人手机",
		"email" : "邮箱",
        "email_placeholder" : "请如实填写邮箱",
        "region" : "所在地区",
        "region_placeholder" : "市，区，街",
        "address" : "详细地址",
        "address_placeholder" : "请填写详细地址",
        "zip" : "邮政编码",
        "zip_placeholder" : "请填写正确的邮政编码",
        "name_empty" : "请填写收件人姓名",
        "name_less" : "2-50个字符限制",
        "mobile_empty" : "请填写个人手机号码",
        "mobile_less" : "请填写正确格式的手机号码",
        "region_empty" : "请选择所在地区",
        "address_empty" : "请填写详细地址",
        "zip_empty" : "请填写邮政编码",
        "save_use" : "保存并使用",
        "save" : "保存",
        "add" : "新增地址",
        "edit" : "修改收货地址",
        "delete" : "删除",
        "list_title" : "收货地址",
        "list_title_item" : "管理",
        "default" : "默认",
        "list_default" : "默认地址",
        "list_edit" : "编辑",
        "list_delete" : "删除",
        "manage_title" : "管理收货地址",
        "manage_empty" : "您还没有添加收货地址",
        "manage_add" : "添加收货地址",
        "confirm_del" : "确定要删除这条收货地址？",
        "confirm_del_title" : "确认删除",
        "region_select" : "请选择地区",
        "region_cancel" : "取消",
        "region_confirm" : "确定",
    },
    auth:{
        "retrieve" : "密码找回",
        "mobile" : "手机号",
        "email" : "邮箱",
        "go_signin" : "去登录",
        "sure" : "确定",
        "signin" : "登录",
        "signup" : "注册",
        "fast_signup" : "快速注册",
        "email_signup" : "邮箱注册",
        "agree" : "点击注册表示同意",
        "agreement" : "《用户协议》",
        "signup_succ" : "注册成功",
        "signup_agreement" : "注册协议",
    },
    auth_signin:{
        "username_placeholder" : "用户名/邮箱/手机号",
        "password_placeholder" : "请输入密码",
        "forget" : "忘记密码？",
        "third_party" : "第三方登录",
        "wechat" : "微信",
        "passport_empty" : "请输入密码",
        "passport_less" : "至少输入6位密码",
        "expire" : "登录过期",
        "username_empty" : "请输入用户名",
    },
    auth_bind:{
        "mobile" : "绑定手机",
        "code_placeholder" : "请输入手机验证码",
        "username_placeholder" : "请输入手机号",
        "passport_placeholder" : "设置密码",
        "confirmPassword_placeholder" : "确认密码",
        "tips" : "6-20位数字/字母/符号",
        "finish" : "完成",
        "mobile_less" : "请输入正确格式的手机号",
        "code_empty" : "请输入验证码",
        "code_less" : "请输入6位验证码",
        "password_empty" : "请输入密码",
        "password_less" : "请输入6-20个字符的密码",
        "confirmPassword_empty" : "请输入确认密码",
        "passport_error" : "确认密码与输入密码不一致",
    },
    auth_email:{
        "confirm_tips" : "密码修改链接已发送至",
        "email_placeholder" : "请输入您的邮箱",
        "tips" : "我们将发送密码修改链接到您绑定的邮箱",
        "send" : "发送邮件",
        "empty" : "请输入邮箱",
        "validator_error" : "邮箱地址不正确",
        "username_placeholder" : "用户名",
        "username_tips" : "用户名为3-25位，可以包含英文与数字",
        "passport_tips" : "6-20位数字/字母/符号",
        "signup_email_placeholder" : "邮箱地址",
        "email_tips" : "请输入邮箱地址",
        "username_empty" : "请输入3-25个字符的用户名",
        "password_empty" : "请输入密码",
        "password_less" : "请输入6-20个字符的密码",
    },
    auth_mobile:{
        "retrieve_succ" : "您的密码已通过手机找回的方式修改成功"
    },
    balance:{
        "usable_title" : "可用资金",
        "desc" : "可用资金（¥）",
        "withdraw" : "提现",
        "withdraw_history" : "提现记录",
        "withdraw_show" : "查看资金明细",
        "history_title" : "资金明细",
        "history_empty" : "暂无明细",
        "history_all" : "全部",
        "history_income" : "收入",
        "history_expend" : "支出",
    },
    withdraw:{
        "history_title" : "提现记录",
        "history_empty" : "暂无记录",
        "history_confirm" : "是否取消该提现",
        "history_confirm_title" : "确认取消",
        "title" : "提现",
        "succ_title" : "提现申请已提交",
        "succ_desc" : "请等待后台人员审核",
        "amount" : "提现金额",
        "remarks" : "备 注",
        "btn_finish" : "完成",
        "subtitle" : "提现金额",
        "tips" : "超过可提现的范围",
        "mentioning_balances" : "可提余额",
        "all" : "全部提现",
        "remark_placeholder" : "请填写银行名称和银行卡号",
        "btn_submit" : "提交",
        "amount_empty" : "请填写提现金额",
        "remark_empty" : "请填写银行名称和银行卡号",
        "item_title" : "商家备注",
        "item_amount" : "提现金额",
        "item_time" : "申请时间",
        "item_remark" : "会员备注",
        "item_cancel" : "取消提现",
        "wait" : "待处理",
        "finish" : "提现成功",
        "cancel" : "已取消",
        "failed" : "提现失败",
    },
    bonus:{
       "list_title" : "我的推荐",
       "recommended" : "已推荐",
       "amount" : "已分成",
       "rule" : "分成规则",
       "balance" : "可用资金",
       "recommend" : "我推荐的会员",
       "order_empty" : "暂无推荐订单",
       "recommend_rank" : "等级",
       "recommend_amount" : "人数",
       "recommend_score" : "积分分成",
       "recommend_price" : "现金分成",
       "recommend_empty" : "暂无推荐",
       "order_sn" : "订单号",
       "cash" : "现金",
       "wait" : "审核中",
       "finish" : "已分成",
       "cancel" : "已取消",
       "revoke" : "已撤销",
       "type_signup" : "推荐注册分成",
       "type_order" : "推荐订单分成",
       "score_signup" : "等级积分",
       "score_order" : "消费积分",
       "my_qrcode" : "我的推广二维码",
       "qr_desc" : "扫描二维码，关注我的小店",
       "qr_share" : "分享小店",
       "qr_copy" : "复制链接",
       "qr_share_title" : "推荐分成",
       "qr_share_desc" : "点击链接关注小店成为推广员，拿取更多分成",
       "qr_link" : "已为您生成推广链接",
       "btn_confirm" : "确认",
    },
    cart:{
        "title" : "购物车",
        "edit" : "编辑",
        "finish" : "完成",
        "select_all" : "全选",
        "total" : "合计",
        "delete" : "删除",
        "checkout" : "结算",
        "empty" : "您的购物车还是空的",
        "no_signup" : "登录后即可查看购物车中的商品",
        "gohome" : "随便逛逛",
        "gosignin" : "去登录",
        "sold_out" : "已售罄",
        "only_left" : "仅剩",
        "piece" : "件",
        "promos_tag" : "促销",
        "delete_empty" : "当前没有可删除的商品",
        "no_reduce" : "受不了了， 宝贝不能再少了",
        "out_of_stock" : "该商品总库存不足",
        "promos" : "已满足",
        "un_promos" : "未满足的优惠",
        "order_promos" : "订单促销",
    },
    cashgift:{
        "list_title" : "我的红包",
        "list_empty" : "暂无红包",
        "unuse" : "未使用",
        "used" : "已使用",
        "expired" : "已过期",
        "bonus_sn_placeholder" : "请输入红包序列号",
        "bonus_add" : "添加红包",
        "bonus_sn_empty" : "请输入10位的序列号",
        "bonus_add_succ" : "红包添加成功",
        "no_use_bonus" : "不使用红包",
        "full" : "满",
        "can_use" : "元可使用",
    },
	coupon: {
		"list_title" : "我的优惠券",
		"list_empty" : "暂无优惠券",
		"full" : "满",
		"can_use" : "元可使用",
		"unuse" : "未使用",
		"used" : "已使用",
		"expired" : "已过期",
		"redbag_title" : "我的红包",
		"can_use_coupon" : "可使用优惠券",
		"no_use_coupon" : "不使用优惠券",
		"redbag_empty" : "暂无红包",
		"piece" : "张",
	},
    category:{
        "title" : "分类",
        "all" : "全部",
		"enter": '进入',
		"column": '栏目'
    },
    checkout:{
        "title" : "确认订单",
        "title_shipping" : "配送方式",
        "title_invoice" : "发票类型",
        "title_cashgif" : "使用红包",
        "title_product_price" : "商品金额",
        "title_tax_price" : "发票税额",
        "title_shipping_price" : "运费",
        "total_price" : "实付款",
        "btn_checkout" : "提交订单",
        "shipping_empty" : "请选择配送方式",
        "consignee_empty" : "请填写收货地址",
        "cashgift_unuse" : "未使用",
        "cashgift_nouse" : "无可用",
        "cashgift_tips" : "已选1张",
        "cashgift_canuse" : "张可用",
        "no_invoice" : "不要发票",
        "invoice_type_empty" : "请选择发票类型",
        "no_shipping_price" : "免运费",
        "goback_mess" : "好货不等人</br>请三思而行",
        "goback_cancel_text" : "去意已决",
        "goback_confirm_text" : "再想想",
        "invoice_header" : "设置发票信息",
        "invoice_type_title" : "发票类型",
        "invoice_tips" : "（单位须填写税号）",
        "invoice_title" : "发票抬头",
        "invoice_personal" : "个人/单位",
        "invoice_content" : "发票明细",
        "invoice_btn_submit" : "确认",
        "invoice_empty" : "请填写完整发票信息",
        "shipping_price" : "配送费",
        "goods_list_header" : "商品清单",
        "total" : "共:",
        "piece" : " 件",
        "score_header" : "积分抵扣",
        "score_most" : "最多可用",
        "score" : "积分",
        "deduct_from" : "每积分抵扣 ￥",
        "rmb" : "元",
        "no_score" : "无可用积分",
        "score_placeholder" : "在此输入积分",
        "delivery_time" : "送货时间",
        "comment_title" : "买家留言",
        "comment_placeholder" : "选填：对本次交易的说明（建议填写已和卖家协商一致的内容）,有定制产品需求的也在这里留言。",
        "address_empty" : "您还没有收获地址，点击这里添加。",
        "promos_preferential" : "优惠金额",
        "promos_cashgift" : "红包",
        "promos_score" : "积分",
        "promos_order_reduction" : "订单促销",
        "promos_goods_reduction" : "商品促销",
        "promos_coupon_reduction" : "优惠券",
        "promos_combined_promos" : "团购",
        "promos_transport_title" : "运费",
        "tax_header" : "税号",
        "tax_tips" : "税号为什么要填写",
        "company_info" : "公司信息",
        "company_name" : "单位名称",
        "company_tax_number" : "纳税人识别号",
        "company_address" : "注册地址",
        "company_tel" : "注册电话",
        "company_bank" : "开户银行",
        "company_bank_account" : "银行账户",
        "collector_info" : "收票人信息",
        "collector_name" : "收票人姓名",
        "collector_tel" : "收票人手机",
        "collector_address" : "详细地址",
        "invoice_yes" : "发票信息",
        "invoice_yes_vat" : "已索取增值税专用发票",
        "invoice_yes_normal" : "已索取增值税普通发票",

        "coo": '需要原产地证书',
        "coo_fee": '产地证书费用',
        "yes": '是',
        "no": '否'
        
    },
    payment:{
        "header" : "收银台",
		"paypal_cancel_header": '取消状态',
        "order_succ" : "订单提交成功，请选择付款方式",
        "total_price" : "合计",
        "teegon_wechat" : "天工收银微信支付",
        "btn_pay" : "立即付款",
        "goback_mess" : "商品一眨眼就没了</br>确定放弃支付吗？",
        "goback_cancel_text" : "去意已决",
        "goback_confirm_text" : "再想想",
        "code_empty" : "请选择支付方式",
        "succed_header" : "购买成功",
        "order_succed" : "订单提交成功",
        "order_fail" : "订单提交失败",
        "exchange_order_succed" : "恭喜您，兑换成功",
        "exchange_order_fail" : "兑换失败",
        "order_detail" : "订单详情",
		"exchange_order_cancel_succ": "已取消兑换",
		"exchange_order_cancel_fail": "取消兑换失败",
		"order_cancel_succ": "已取消支付",
		"order_cancel_fail": "取消支付失败"
    },
    discount:{
        "header" : "优惠活动",
        "empty" : "暂无优惠活动",
        "range_0" : "全部商品可用",
        "range_1" : "部分分类可用",
        "range_2" : "部分品牌可用",
        "range_3" : "部分商品可用",
        "range_canuse" : "可用",
        "is_end" : "活动已结束",
        "waiting" : "敬请期待",
        "is_waiting" : "活动未开始",
        "list_empty" : "暂无任何商品",
        "no_more" : "没有更多了",
        "review_rate" : "好评",
        "sales_count" : "销量",
        "surplus" : "剩余",
        "day" : "天",
        "hour" : "时",
        "minute" : "分",
        "second" : "秒",
    },
    promotions:{
        "no_more" : "没有更多了",
        "endtime" : "距离活动结束时间",
        "day" : "天",
        "hour" : "时",
        "minute" : "分",
        "second" : "秒",
    },
    home:{
        "goodproduct" : "热门推荐",
        "hotproduct" : "销量排行",
        "recentproduct" : "新品上架",
		"suitproducts": "组合商品",
        "header_placeholder" : "想找什么？",
        "menu_activity" : "优惠活动",
        "menu_integralmall" : "积分商城",
        "menu_order" : "订单",
        "menu_bonus" : "红包",
		"menu1": "外骨骼、四足",
		"menu2": "机械臂",
		"menu3": "云台系统",
		"menu4": "产品分类",
		"menu5": "我的",
        "product_buy" : "人已购买",
        "share_title" : "推荐分成",
        "share_desc" : "点击链接关注小店成为推广员，拿取更多分成",
    },
    integralmall:{
        "header" : "积分商城",
        "hotproduct" : "热销商品",
        "allproduct" : "全部商品",
        "no_more" : "没有更多商品了",
        "score" : "积分",
    },
    message:{
        "header" : "消息中心",
        "order" : "订单消息",
        "notice" : "通知消息",
        "empty" : "暂无信息",
        "no_message" : "您还没有消息通知",
    },
    order:{
        "header" : "我的订单",
        "empty" : "您的订单为空",
        "gohome" : "随便逛逛",
        "copy" : "复制",
        "all" : "全部",
        "created" : "待付款",
        "paid" : "待发货",
        "status_cancelled" : "已取消",
		"back_info": "转账信息",
        "status_finished" : "已完成",
        "status_deliveried" : "待评价",
        "status_delivering" : "配送中",
        "nav_delivering" : "待收货",
        "nav_deliveried" : "待评价",
        "comment_3" : "好评",
        "comment_2" : "中评",
        "comment_1" : "差评",
        "sn" : "订单编号",
        "total" : "共计",
        "total_price" : "合计",
        "product" : "件商品",
        "shipping_price" : "含运费",
        "btn_cancel" : "取消订单",
        "cancels" : "取消",
        "cancels_finish" : "完成",
        "go_payment" : "去支付",
        "btn_track" : "查看物流",
        "btn_confirm" : "确认收货",
        "btn_comment" : "评价晒单",
        "no_want" : "不想要了",
        "no_payment" : "支付不成功",
        "no_price" : "价格较贵",
        "no_store" : "缺货",
        "long_wait" : "等待时间过长",
        "confirm_title" : "确认收货",
        "confirm_content" : "是否确认收货？",
        "cancel_reason_empty" : "请选择取消原因",
        "detail_header" : "订单详情",
        "detail_status_0" : "等待付款",
        "detail_status_1" : "待发货",
        "detail_status_2" : "配送中",
        "detail_status_3" : "待评价",
        "detail_status_4" : "已完成",
        "detail_status_5" : "已取消",
        "detail_status_6" : "配货中",
        "detail_score" : "积分",
        "detail_more" : "还有",
        "piece" : "件",
        "add_time" : "下单时间",
        "is_exchange_good_pay" : "支付方式：积分兑换",
        "payment" : "支付方式",
        "shipping" : "配送方式",
        "product_price" : "商品总额",
        "tax_price" : "发票税额",
        "detail_shipping_price" : "运费",
        "detail_total_price" : "实付款",
        "copy_succed" : "复制成功",
        "no_shipping_price" : "免运费",
        "track_header" : "订单跟踪",
        "track_vendor_name" : "承运来源",
        "trade_header" : "交易成功",
        "trade_succed" : "交易成功，卖家将收到您的货款！",
        "go_comment" : "立即评价",
        "go_detail" : "订单详情",
        "check_detail" : "查看订单",
        "comment_header" : "评价宝贝",
        "comment_submit" : "提交",
        "comment_content" : "请在此输入评价",
        "comment_content_empty" : "请评价商品",
        "comment_succed" : "评论成功",
        "comment_succed_tips" : "商品评论成功，感谢您给予的评价。",
        "comment_gohome" : "再去逛逛",
    },
    product:{
        "sort_default" : "综合排序",
        "sort_price_asc" : "价格从低到高",
        "sort_price_desc" : "价格从高到低",
        "sort_credit_desc" : "好评率",
        "sort_sale_desc" : "销量排序",
        "sort_date_desc" : "新品上架",
        "product_tab" : "商品",
        "detail_tab" : "详情",
        "evaluate_tab" : "评价",
        "parameter_tab" : "规格参数",
        "recom_tab" : "推荐配置",
        "packing_tab" : "包装清单",
        "keyword_placeholder" : "请输入您要搜索的商品",
        "keyword_empty" : "请输入您要搜索的关键字",
        "sold_out" : "已售罄",
        "only_left" : "仅剩",
        "piece" : "件",
        "self_support" : "自营",
        "review_rate" : "好评",
        "sales_count" : "销量",
        "add_cart_succ" : "加入成功",
        "empty" : "暂无任何商品",
		"no_more" : "没有更多了",
	},
    product_detail:{
        "total" : "全部",
        "good" : "好评",
        "medium" : "中评",
        "bad" : "差评",
        "review" : "评价",
        "add_cart" : "加入购物车",
        "fastbuy" : "立即购买",
        "exchange" : "立即兑换",
        "not_stock" : "所选产品暂时无货，非常抱歉！",
        "not_enough_score" : "积分不足",
        "sure" : "确定",
        "properties_empty" : "请选择商品属性",
        "not_enough_stock" : "商品库存不足",
        "exchange_title" : "确认兑换",
        "exchange_message_1" : "是否使用",
        "exchange_message_2" : "积分兑换",
        "cancel_btn" : "取消",
        "confirm_btn" : "确认",
        "wechat_config_title" : "商品详情",
        "score" : "积分",
        "stock" : "库存",
        "number" : "数量",
        "max_number" : "商品达到每单限购数量",
        "no_reduce" : "受不了了， 宝贝不能再少了",
        "no_desc" : "本商品暂无详情",
        "infobuy_number_select" : "请选择购买",
        "infobuy_number" : "数量/分类",
        "infobuy_selectd" : "已选",
        "infobuy_number_selectd" : "已选数量",
        "concat" : "点击联系客服",
        "current_day" : "当天",
        "next_day" : "次日",
        "month" : "月",
        "day" : "日",
        "like" : "点赞",
        "promos_time_title" : "距离活动结束时间",
        "day_1" : "天",
        "hour" : "时",
        "minute" : "分",
        "second" : "秒",
        "promos_info_title" : "促销信息",
        "info_header" : "商品详情",
        "review_content_empty" : "无评价信息",
        "review_empty" : "本商品暂无评价",
        "recommend_show_all" : "查看全部",
        "suit_goods_selected_empty" : "请选择已选商品的所有属性!",
        "parameter" : "参数",
    },
    profile:{
        "score" : "积分",
        "record_list" : "积分记录",
        "order_header" : "我的订单",
        "order_all" : "查看全部订单",
        "order_status_0" : "待付款",
        "order_status_1" : "待发货",
        "order_status_2" : "待收货",
        "order_status_3" : "完成",
        "favourite_header" : "我的收藏",
        "address_header" : "管理收货地址",
        "cashgift_header" : "我的红包",
        "addcashgift_header" : "添加红包",
        "bonus_header" : "我的推荐",
        "balance_header" : "我的资金",
        "help_header" : "使用帮助",
        "bonus_qr_header" : "我的推广二维码",
        "nickname_title" : "登录/注册",
        "setting_header" : "帮助指南",
        "about" : "关于我们",
        "contact" : "联系我们",
        "Payment" : "支付指南",
        "help" : "订单帮助",
        "Postsale" : "售后服务",
        "warranty" : "保修政策",
        "signout" : "退出登录",
        "signout_confirm" : "确认退出",
        "info_header" : "个人资料",
        "edit_nickname" : "修改昵称",
        "gender" : "性别",
        "edit_pwd" : "修改密码",
        "male" : "男",
        "female" : "女",
        "secret" : "保密",
        "nickname_placeholder" : "请输入昵称",
        "nickname_empty" : "请输入1-25个文字作为昵称",
        "nickname_succ" : "修改昵称成功",
        "oldpass_empty" : "当前密码不能为空",
        "pass_less" : "请输入6-20个字符的密码",
        "newpass_empty" : "新密码不能为空",
        "confirpass_empty" : "请输入确认密码",
        "confirpass_false" : "确认密码与输入密码不一致",
        "btn_save" : "保存",
        "add_header" : "完善资料",
        "skip" : "跳过",
        "add_tips" : "带“*”为必填项",
        "add_submit" : "完成",
        "placeholder" : "请填写",
        "add_succ" : "完善信息成功",
        "product_empty" : "暂无商品",
        "gohome" : "随便逛逛",
        "not_stock" : "无货",
        "only_left" : "仅剩",
        "piece" : "件",
        "delete" : "删除",
        "confirm_del_title" : "确认删除",
        "confirm_del_mess" : "是否要删除此商品？",
        "share" : "分享",
        "share_refresh" : "刷新",
        "share_to" : "分享到",
        "share_wechat" : "微信",
        "share_blog" : "微博",
        "share_qq" : "QQ",
        "share_cancel" : "取消",
        "change_avatar" : "更换头像",
        "change_avatar_placeholder" : "请选择头像",
        "upload" : "上传中...",
        "image_type" : "图片类型必须是.gif,jpeg,jpg,png,bmp中的一种",
    },
    recommend:{
        "product" : "相关商品",
        "accessory" : "相关搭配",
        "no_more" : "没有更多了",
    },
    score:{
        "header" : "我的积分",
        "can_use" : "当前可用积分",
        "all" : "全部",
        "income" : "收入",
        "expend" : "支出",
        "empty" : "暂无积分记录",
        "exchange_succ" : "积分兑换成功",
        "rule_header" : "积分规则",
        "have_score" : "获得积分",
        "expend_score" : "支付积分",
        "item_score" : "积分",
        "platform" : "适用平台",
        "to_exchange" : "立即兑换",
        "confirm_use" : "确定使用",
        "exchange_score" : "积分，兑换",
        "coupon" : "元优惠券吗？",
        "confirm_btn" : "确认",
		"tip_message" : '即将到账的积分将在付款成功后</br>自动充值到总积分当中！',
		"tip_btn_text" : "知道了",
    },
    search:{
        "header" : "最近搜索",
        "hot_header" : "热门搜索",
        "placeholder" : "请输入您要搜索的商品",
        "cancel" : "取消",
        "keyword_empty" : "请输入您要搜索的关键字",
    },
}



// WEBPACK FOOTER //
// ./src/assets/i18n/zh_cn.js